import { createContext, useContext, useMemo, useState, useCallback } from "react";
import es from "./es";
import ca from "./ca";

const LANGS = { es, ca };
const LangContext = createContext(null);

const ALT = { es: "/ca/", ca: "/" };

export function LangProvider({ children }) {
  const initial = window.location.pathname.startsWith("/ca") ? "ca" : "es";
  const [lang, setLangState] = useState(initial);

  const setLang = useCallback((l) => {
    if (!LANGS[l]) return;
    const path = window.location.pathname;
    const rest = path.startsWith("/ca") ? path.slice(3) || "/" : path;
    const target = l === "ca" ? `/ca${rest === "/" ? "/" : rest}` : rest;
    setLangState(l);
    window.history.pushState({}, "", target);
  }, []);

  const t = useCallback(
    (key) => {
      const val = key.split(".").reduce((o, k) => (o ? o[k] : undefined), LANGS[lang]);
      if (val !== undefined) return val;
      const fb = key.split(".").reduce((o, k) => (o ? o[k] : undefined), es);
      return fb !== undefined ? fb : key;
    },
    [lang]
  );

  const altPath = useMemo(() => {
    const path = window.location.pathname;
    const rest = path.startsWith("/ca") ? path.slice(3) || "/" : path;
    return lang === "es" ? `/ca${rest === "/" ? "/" : rest}` : rest;
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, altPath, other: lang === "es" ? "ca" : "es" }),
    [lang, setLang, t, altPath]
  );
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
